import React, { useState, useRef, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import "./ModuleContent.scss";
import ModuleListCard from "./ModuleListCard";
import { TextField } from "@material-ui/core";
import {
  DropDownField,
  SearchTextField,
  TextFields,
  SearchTextFieldTemplate
} from "../../ResuableComponent/CustomModal/TextFields/TextFields";
import { Modal } from "react-bootstrap";
import { getmmModules, searchForDetails, getModuleCardDetails, getIndicationDetails, getMarketDetails, getBrandDetails } from "../../../services/apis";
import CircularProgressBar from "../../../utils/CircularProgressBar";
import NoResultsFound from "../../../images/Noresults.svg";
import NoImportResultFound from "../../../images/NoImportResultFound.svg";
import NoModuleImportFound from "../../../images/NoModuleImportFound.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import SelectedModuleModal from "./SelectedModuleModal";
import ModuleContentCardDetailsModal from "./ModuleContentCardDetailsModal";
import SelectAutoComplete from "../../ResuableComponent/SelectAutoComplete/SelectAutoComplete";
import SelectTemplateCard from "./SelectTemplateCard";
import CrossIcon from "../../../images/clearTextIcon.svg";

import ModuleView from "../ModulePreview/ModuleView";
import MultiselectDropdown from "../../ResuableComponent/MultiSelectDropdown/MultiSelectDropdown";
import dropdownArrow from "../../../images/gilead- collapse-dropdown.svg";
import MultiSelectDropdownWithCount from "../../ResuableComponent/MultiSelectDropdownWithCount/MultiSelectDropdownWithCount";

const ModuleContent = ({
  setActiveNextButton,
  selectedModuleIds,
  setSelectedModuleIds,
  setSwitchCustomJs,
  switchCustomJs,
  setModuleDetails,
  brands,
  appData,
  market,
  from,
  basicDetail,
  modulePage,
  setPayloadData,
  payloadData,
  setModulesSelected,
  modulesSelected,
  closeTootltipTitle,
  closeTootltip,
  setSelectedModulesData,
  selectedModulesData,
  isOneTimeContent,
}) => {
  const cardRef = useRef();
  const cardBtnRef = useRef();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState([]);
  const [moduleCardList, setModuleCardList] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedNextModuleList, setSelectedNextModuleList] = useState([]);
  // const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [disabledModules, setDisabledModules] = useState([]);
  const [disabledModulesOptional, setDisabledOptionalModules] = useState([]);
  const [disabledMustExistModules, setDisabledMustExistModules] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [enableResetBtn, setEnableResetBtn] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [cradDetails, setCardDetails] = useState({});
  const [storedData, setStoredData] = useState({});
  const [hasMoreTemplate, setHasMoreTemplate] = useState(false)
  const [skipRange, setSkipRange] = useState(0)
  const [showFetchedResults, setshowFetchedResults] = useState([]);
  const [searchTextTemplate, setSearchTextTemplate] = useState("");
  const [templateSelected, setTemplatedSelected] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  const [templateApiLoading, setTemplateApiLoading] = useState(false);
  const [templateApiResolved, setTemplateApiResolved] = useState(false);
  const limit = 100;
  const [moduleData, setModuleData] = useState([]);
  const [searchEmpty, setIsSearchBarEmpty] = useState(true);
  const [selectedIndication, setSelectedIndication] = useState([]);
  const [indicationsList, setIndicationsList] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [brandsList, setBrandsList] = useState([]);

  const infinteScrollRef = useRef();
  const prevSearchText = useRef(null);
  const prevSearchTextTemplate = useRef(null);
  const [selectedIndications, setSelectedIndications] = useState([]);
  const [selected, setSelected] = useState([]);
  /* const primaryCountry =
    from === "edit"
      ? market.find((li) => li._id === appData.deckId.market)
      : market
      ? market
      : "";
  const primaryProduct =
    from === "edit"
      ? brands.find((li) => li._id === appData.deckId.brand)
      : brands
      ? brands
        : ""; */
  let localdata = JSON.parse(localStorage.getItem("basicEdetailData")) || {};
  if (from === "edit") {
    localdata['brand'] = brands.find((li) => li._id === appData?.deckId?.brand);
    localdata['market'] = market.find((li) => li._id === appData?.deckId?.market)
  }
  
  useEffect(() => {
    if (from !== 'edit') {
      setSearchTextTemplate('')
      setSearchText('')
      console.log('hjk')
      setSelectedIndications([]);
      setSelected([]);
      setTemplatedSelected([])
     // fetchMoreTemplate('all', 0, false, false)
      setPayloadData({ brand: localdata?.brand?._id, market: localdata?.market?._id, name: localdata?.edetailName, type:localdata?.type, docNumber:localdata?.docNumber, indication: localdata?.indication });
    }
    
   },[modulePage]);

  useEffect(() => {
    if (searchText.trim() === "" && prevSearchText.current !== "") {
      getModuleContentDetails();
      if(searchText.trim().length > 0 || selectedIndications.length > 0) {
        setEnableResetBtn(true);
      } else {
        setEnableResetBtn(false);
      }
      // setLoading(true);
    }
  }, [searchText.trim().length > 0 ]);

  useEffect(() => {
    const getModuleContentDetailss = () => {
      const payload = {
        productName: localdata?.brand?.name,
        countryName: localdata?.market?.name,
        searchText: searchText,
        topicName: "",
        subtopicName: "",
        segmentNames: [],
        page: page,
      };

      prevSearchText.current = searchText;
  
      getmmModules(payload, (response, err, ErrorCode) => {
        setLoading(true);
        if (err) {
          setLoading(false);
          console.log("search module error", err);
          // toastError();
        } else {
          
          const data = response?.data?.data || [];
          const listData = data.filter(li => li.mlrStatus === 'Available for Use');
          setModuleCardList([...moduleCardList, ...listData]);
          // setModuleCardList(data);
          setModuleDetails(listData);
          setModuleDetails([...moduleCardList, ...listData]);
          if(response.data.totalElements <= [...moduleCardList, listData].length) {
            setHasMore(false);
          } else if(response.data.totalElements >= [...moduleCardList, listData].length) {
            setHasMore(true);
          }
          setLoading(false);
        }
      });
    };
    getModuleContentDetailss();

    getIndicationDetails((response, error) => {
      if (!error && response?.data) {
        setIndicationsList(response.data);
      } 
    })

    getMarketDetails((response, err, errCode) => {
      if (err) {
      } else {
        if (response) {
          setCountriesList(response.data);
        }
      }
    });

    getBrandDetails((response, err, errCode) => {
      if (err) {
      } else {
        if (response) {
          setBrandsList(response.data);
        }
      }
    });
  }, []);

  // useEffect(() => {
  //   getSearchCriteria(selectedIndications, "Indication");
  // },[selectedIndications]);

  const getSearchCriteria= (selectedItem, selectedOption, c) => {
    if(selectedOption === "Indication") {
      setSelectedIndication(selectedItem);
    }

    if(selectedItem.length > 0) {
      setEnableResetBtn(true);
    } else if(selectedItem.length === 0 && searchText.trim().length == 0 && searchTextTemplate.trim().length == 0 ) {
      setEnableResetBtn(false);
    }
  }

  const getModuleContentDetails = () => {
    setPage(0);
    const payload = {
      productName: localdata?.brand?.name,
      countryName: localdata?.market?.name,
      searchText: searchText,
      topicName: "",
      subtopicName: "",
      segmentNames: [],
      page: 0,
    };

    prevSearchText.current = searchText;

    getmmModules(payload, (response, err, ErrorCode) => {
      setLoading(true);
      if (err) {
        setLoading(false);
        console.log("search module error", err);
        // toastError();
      } else {
        const data = response?.data?.data || [];
        const listData = data.filter(li => li.mlrStatus === 'Available for Use');
        setModuleCardList(listData);
        setModuleDetails([...moduleCardList, ...listData]);
        // setModuleDetails(data);
        if(response.data.totalElements <= [...moduleCardList, listData].length) {
          setHasMore(false);
        } else if(response.data.totalElements >= [...moduleCardList, listData].length) {
          setHasMore(true);
        }
        setSearchedData(listData);
        setLoading(false);
      }
    });
  };

  const handleViewClick = (e, list) => {
     e.stopPropagation();

    getModuleCardDetails(list.id, (response, err, errorCode) => {
                setLoading(true);
                if (err) {
                    console.log(err);
                    setLoading(false);
                } else {
                    let resp = response.data;
                    setLoading(false);
                    setCardDetails(resp);
                    setIsPopupVisible(!isPopupVisible);
                    
                }
            })
   

    
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        cardBtnRef.current &&
        !cardBtnRef.current.contains(e.target) &&
        cardRef.current &&
        !cardRef.current.contains(e.target)
      ) {
        setIsPopupVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleCardClick = (moduleId, associatedModule, moduleParent) => {
    if (disabledModules.includes(moduleId)) {
      return;
    }
    if (disabledMustExistModules.includes(moduleId)) {
      return;

    }

    if (selectedModuleIds.includes(moduleId)) {
      setSelectedModuleIds(selectedModuleIds.filter((id) => id !== moduleId));
    
      from !== 'edit' && setModulesSelected(modulesSelected.filter((item) => item.id !== moduleId));
    } else {
     
      setSelectedModuleIds([...selectedModuleIds, moduleId]);
      const list = moduleCardList.find((card)=> card.id == moduleId)
    from !== 'edit' && setModulesSelected([...modulesSelected, list])
    }

  };

  // Handling border color of the card
  const getModuleStyle = (moduleId) => {
    const isSelected = selectedModuleIds.includes(moduleId);
    const isDisabled = disabledModules.includes(moduleId);
    const disabledMustExist = disabledMustExistModules.includes(moduleId);
    if (selectedModuleIds.length > 0) {
      setActiveNextButton(true);
    } else {
      setActiveNextButton(false);
    }
    if (isSelected) {
      return 'seleted-module-card'
      // return { border: "1px solid #DCE2EA", cursor: "pointer" }; // Selected card
    }

    if (isDisabled) {
      return 'disabled-module-card'
      // return { border: "1px dashed #E32B35", cursor: "not-allowed", background: '#F2F3F3' }; // Disabled card
    }
    if (disabledMustExist) {
      return 'disabled-must-exist-module-card'
      // return { border: "1px solid #DDDFDD", cursor: "default" }; // Default card style
    }
  };

  React.useEffect(() => {
    const disabled = [];
    const disabledMustExist = [];
    selectedModuleIds.forEach((moduleId) => {
      const module = moduleData?.find((mod) => mod.id === moduleId);
      if (module) {
        const canNotExistModule = module.moduleBusinessRules.filter(
          (rule) => rule.ruleCondition === "CannotExistWith"
        );
        const optionalModule = module.moduleBusinessRules.filter(
          (rule) => rule.ruleCondition === "Optional"
        );
        const mustExistModule = module.moduleBusinessRules.filter(
          (rule) => rule.ruleCondition === "MustExistWith"
        );
        if (canNotExistModule.length > 0) {
          canNotExistModule?.forEach((rule) => {
            if (!selectedModuleIds.includes(rule.targetModuleId)) {
              disabled.push(rule.targetModuleId);
            }
          });
        }
        if (mustExistModule.length > 0) {
          mustExistModule?.forEach((rule) => {
            if (!selectedModuleIds.includes(rule.targetModuleId)) {
              disabledMustExist.push(rule.targetModuleId);
            }
          });
        }
      }
    });
    setDisabledModules([...new Set(disabled)]);
    setDisabledMustExistModules([...new Set(disabledMustExist)]);
  }, [selectedModuleIds, moduleCardList]);

  // Setting value in Search state
  const searchfieldsHandler = (e) => {
    setSearchText(e.target.value);
  };

  // Clear Search Field Handler
  const cancelSearchField = () => {
    setSearchText("");
    if(selectedIndications.length > 0) {
      setEnableResetBtn(true);
    } else {
      setEnableResetBtn(false); // Disabling reset button, when user click on x icon
    }
  };

  // Resetting Search Field Handler
  const resetSelectedValue = () => {
    if (searchText.trim().length > 0 || searchTextTemplate.trim().length > 0 || selectedIndications.length > 0) {
      // setLoading(true);
      setSearchText("");
      setSearchTextTemplate("")
      setSelectedIndications([]);
      setSelected([]);
      setEnableResetBtn(false);
    }
  };
  useEffect(() => {
    if(selectedIndications.length > 0 || searchText.trim().length > 0) {
      setEnableResetBtn(true);
    } else {
      setEnableResetBtn(false);
    }
  }, [selectedIndications]);
console.log(searchText, 'searchText')
  // Resetting Search Field Handler with indication
  const resetSelectedAllValue = () => {
    if(searchText.trim().length > 0 || searchTextTemplate.trim().length > 0 || selectedIndications.length > 0) {
    // if (searchTextTemplate.trim().length > 0 || selectedIndication.length > 0) {
      // setSelectedIndication([]);
      setSearchTextTemplate("")
      setSelectedIndications([]);
      setSelected([]);
      setEnableResetBtn(false);
    }
  }

  // Press Enter, Search Field Handler  
  const handleEnterKeypress = (event) => {
    if (searchText.trim().length > 0 || selectedIndications.length > 0) {
      if (event.key === "Enter") {
        setEnableResetBtn(true);
        setLoading(true);
        getModuleContentDetails();
      }
    }
  };

  // Search Field Handler
  const searchHandler = () => {
    if (searchText.trim().length > 0 || selectedIndications.length > 0) {
      setEnableResetBtn(true);
      setLoading(true);
      getModuleContentDetails(); // Api calling on search 
    }
  };

  // Pagination api
  const fetchMore = (page) => {
    setPage(page);
    // const getModuleContentDetails = () => {
    const payload = {
      productName: localdata?.brand?.name,
      countryName: localdata?.market?.name,
      searchText: searchText,
      topicName: "",
      subtopicName: "",
      segmentNames: [],
      page: page,
    };

    getmmModules(payload, (response, err, ErrorCode) => {
      setLoading(true);
      if (err) {
        setLoading(false);
        console.log("search module error", err);
        // toastError();
      } else {
        setLoading(false);
        const data = response?.data?.data || [];
        const listData = data.filter(li => li.mlrStatus === 'Available for Use');
        
        if(response.data.totalElements <= [...moduleCardList, ...listData].length) {
          setHasMore(false);
        } else if(response.data.totalElements >= [...moduleCardList, ...listData].length) {
          setHasMore(true);
        }
        setModuleCardList([...moduleCardList, ...listData]);
        setModuleDetails([...moduleCardList, ...listData]);
        setSearchedData([...moduleCardList, ...listData]);
      }
    });
    // }
  };

  // Close View card
  const closeCardDetailsModal = () => {
    setIsPopupVisible(false);
  };

  const templateListUI = (props, option, { selected }) => {
    const { key, ...optionProps } = props;
    return (
      <li {...props} className="dropdown-list-css">
        <span>{option.name || option}</span>
      </li>
    );
  };

  const fetchMoreTemplate = (createdby, skipRange, moreData, expired) => {
    setTemplateApiLoading(true);
    setTemplateApiResolved(false);
    const countryName = localdata?.market?.name;
    prevSearchTextTemplate.current = searchTextTemplate.trim();
        setLoading(true);
          let searchPayload = {
            searchInput: searchTextTemplate.trim(),
            brand: localdata?.brand?._id,
            market: localdata?.market?._id, //marketID === undefined ? "" : marketID._id,
            type: 1,
            skip: skipRange,
            limit: 100,
            created: createdby,
            expired: false,
            mlrStatus: countryName?.toUpperCase() === "GLOBAL"?'GRC Process Complete':'Approved for Use'
          };
          searchForDetails(searchPayload, (response, err, errorCode) => {
            if (err) {
              setTemplateApiLoading(false);
              setTemplateApiResolved(true);
              setLoading(false);
             // toast.error("Failed to fetch ");
            } else {
              const data = response.data?.response?.decks;
              let totalData = 0;
              if (moreData) {
                totalData = [...showFetchedResults, ...data];
              } else {
                totalData = [...data];
              }
              if (response.data.response?.totalCount <= totalData.length) {
                setHasMoreTemplate(false);
                setLoading(false);
              } else if (response.data?.response?.totalCount >= totalData.length) {
                setHasMoreTemplate(true);
              }
              setshowFetchedResults(totalData);
              setSkipRange(skipRange + limit);
              setTemplateApiLoading(false);
              setTemplateApiResolved(true);
              setLoading(false);
            }
          });
        }

  const searchTemplateHandler = (e) => {
    let value = e.target.value;
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    setSearchTextTemplate(value);
  }

  const clearField = () => {
    setSearchTextTemplate('')
    if(isOneTimeContent && selectedIndication.length == 0) {
      setEnableResetBtn(false);
    } else if(!isOneTimeContent) {
      setEnableResetBtn(false)
    }
  }

  const getTemplate = (event, action) => {
    if ((searchTextTemplate.trim().length > 0) && 
      ((action == "key" && event.key === "Enter") || action === "click")) {
     setEnableResetBtn(true)
      fetchMoreTemplate('all', 0, false, false)
    }

  }

  useEffect(() => {
    if (searchTextTemplate.trim() === "" && prevSearchTextTemplate.current !== "") {
      fetchMoreTemplate('all', 0, false, false)
      if(isOneTimeContent && selectedIndication.length === 0) {
        setEnableResetBtn(false)
      } else if (!isOneTimeContent) {
        setEnableResetBtn(false)
      }
    }
  },[searchTextTemplate]);

  useEffect(() => {
    getModuleContentMMDetails();
  }, []);

  // Get All MM Data
   const getModuleContentMMDetails = () => {
          const payload = {
            productName: localdata?.brand?.name,
            countryName: localdata?.market?.name,
            searchText: "",
            topicName: "",
            subtopicName: "",
            segmentNames: [],
            page: 0,
          };
      
          prevSearchText.current = "";

          getmmModules(payload, (response, err, ErrorCode) => {
            setLoading(true);
            if (err) {
              setLoading(false);
              console.log("search module error", err);
              // toastError();
            } else {
              const data = response?.data?.data || [];
              const listData = data.filter(li => li.mlrStatus === 'Available for Use');
              
              setModuleData(listData);
              setLoading(false);
            }
          });
        };

  // Filtering based on search data and showing that particular card
  // const filteredData = moduleCardList?.filter(item1 => 
  //   searchedData.some(item2 => item2.moduleDamName === item1.moduleDamName)
  // );

const filteredData = moduleCardList?.filter(module => {

  // 1️⃣ Search filter (by moduleDamName)
  const matchesSearch =
    !searchedData?.length ||
    searchedData.some(searchItem =>
      searchItem.moduleDamName === module.moduleDamName
    );

  // 2️⃣ Dropdown filter (by indication name)
  const matchesDropdown =
    !selectedIndications?.length ||
    module.moduleIndications?.some(indication =>
      selectedIndications.some(selected =>
        selected.name === indication.indicationName
      )
    );

  // Return only if both conditions are true
  return matchesSearch && matchesDropdown;
});
  // const filteredData = moduleCardList?.filter((item) => {
  //   console.log(item.indications)
  //   return selectedIndications.length === 0 ? item : item?.indications && item?.indications?.some((indication) =>
  //     selectedIndications?.some(
  //       (selected) =>{
  //         return selected?.veevaid  &&
  //         selected.veevaid === indication
  //       }
  //     ) 
  //   );
  // });

  const templateFilteredData = showFetchedResults?.filter((item) => {
    return selectedIndications.length === 0 ? item : item.indication.some((indication) =>
      selectedIndications.some(
        (selected) =>{
          return selected?.veevaid  &&
          selected.veevaid === indication
        }
      ) 
    );
  });

  const selectTemplateData = showFetchedResults?.filter((item) => {
    return selectedIndications.length === 0 ? item : item.indication.some((indication) =>
      selectedIndications.some(
        (selected) =>{
          return selected?.veevaid  &&
          selected.veevaid === indication
        }
      ) 
    );
  });

  const showOneTimeTemplateLoader =
    isOneTimeContent &&
    modulePage &&
    !switchCustomJs &&
    (!templateApiResolved || templateApiLoading);

  if(isOneTimeContent) {
    return (
      <>
        {showOneTimeTemplateLoader && (
          <CircularProgressBar isloading={showOneTimeTemplateLoader} setIsloading={setLoading} />
        )}
        <div className="module-content-main">
          <div className="module-content-select-module">
            <div>
              {!switchCustomJs &&  (
                <>
                  <div className="d-flex gap-3" style={{marginTop:10}}>

                    <h2 className="module-content-select-module-text" style={{fontWeight:600, color:"1E1E1E"}}>
                      Select one Template 
                    </h2>
                    <div className="module-content-divider"></div>

                    <div className="module-content-dropdown-list d-flex gap-2">
                      <div className="module-content-label">Product: </div>
                      <div className="module-content-value">{localdata?.brand?.name || 'NA'}</div>
                    </div>
                    <div className="module-content-divider"></div>

                    <div className="module-content-dropdown-list d-flex gap-2">
                      <div className="module-content-label">Country: </div>
                      <div className="module-content-value">{localdata?.market?.name || 'NA'}</div>
                    </div>
                  </div>

                  <div className="module-content-dropdown" style={{border:"none", padding:"14px 20px 10px 0px"}}>
                    <div>
                      <MultiSelectDropdownWithCount
                        options={indicationsList}
                        label="Indication"
                        value={indicationsList}
                        onChange={(val) => setSelectedIndications(val)}
                        placeholderText="Search & Select"
                        selected={selected}
                        setSelected={setSelected}
                        dropdownIcon={<img src={dropdownArrow} style={{marginRight: "3px", marginLeft: "3px"}} width={13} height={8} alt="" />}
                      />
                      {/* <MultiselectDropdown
                        title={"Indication"}
                        multiple={true}
                        data={indicationsList}
                        selectedFilterData={selectedIndication}
                        setIsSearchBarEmpty={setIsSearchBarEmpty}
                        getSearchCriteria={getSearchCriteria}
                        isPdfFlow={true}
                        style={{}}
                      /> */}

                    </div>

                    <div className="module-content-dropdown-list" style={{display:'flex', flexGrow:'1'}}>
                      <SearchTextFieldTemplate
                        onChangeText={searchTemplateHandler}
                        searchTextTemplate={searchTextTemplate}
                        removeText={clearField}
                        onSearch={getTemplate}
                        setSearchTextTemplate={setSearchTextTemplate}
                      />
                    </div>

                    <button
                      className={`module-content-reset-button 
                        ${
                            enableResetBtn
                              ? "module-content-active-reset-button"
                                : "module-content-deactive-reset-button"
                        }`}
                      disabled={enableResetBtn === true ? false : true}
                      onClick={resetSelectedAllValue}
                    >
                      RESET FILTERS
                    </button>
                  </div>

                </>
              )}

              <div className="d-flex">
                <div 
                  style={{fontSize:12, fontWeight:700, color:"#1E1E1E"}}
                >
                  All 
                  <span style={{fontWeight:400}}>
                    {" "}({ templateFilteredData.length })
                  </span>
                </div> 
                <div className="module-content-dash"></div>
              </div>
            </div>
          </div>
          {!switchCustomJs && (
            <div>           
              {modulePage && <div className={`${templateFilteredData?.length < 1 ? 'noContent':''}`}>
                <InfiniteScroll
                  dataLength={templateFilteredData.length}
                  next={() => fetchMoreTemplate('all', skipRange, true, false)}
                  hasMore={hasMoreTemplate}
                  scrollableTarget="scrollableDivTemplate"
                  ref={infinteScrollRef}
                  // loader={<h4>Loading...</h4>}
                  scrollThreshold={0.9}
                >
                  {templateFilteredData?.length > 0 && <div className="module-content-card-parent-div" id="scrollableDivTemplate" style={{maxHeight:"calc(100vh - 286px)"}}>
                    <div className="module-content-card-child-div">
                      {templateFilteredData && templateFilteredData.map((cardData, index) => (
                        <SelectTemplateCard
                          cardData={cardData}
                          imageKey={index}
                          templateSelected={templateSelected}
                          setTemplatedSelected={setTemplatedSelected}
                          showFetchedResults={showFetchedResults}
                          setshowFetchedResults={setshowFetchedResults}
                          setPayloadData={setPayloadData}
                          payloadData={payloadData}
                          isOneTimeContent={isOneTimeContent}
                          countriesList={countriesList}
                          brandsList={brandsList}
                        />
                      ))}
                    </div>
                    
                  </div>}
                </InfiniteScroll> 
                {!templateApiLoading && templateApiResolved && templateFilteredData?.length < 1 && (
                  <div className="d-flex align-items-center justify-content-center">
                    <img src={NoImportResultFound} />
                  </div>
                )}
              </div>}
            </div>
          )}
          {selectedModuleIds.length > 0 && switchCustomJs && (
            <div>
              <SelectedModuleModal
                selectedModuleIds={selectedModuleIds}
                moduleCardList={moduleCardList}
                localdata={localdata}
                moduleData={moduleData}
              />
            </div>
          )}
        </div>

        {isPopupVisible && (
          <ModuleView
            modulePreviewData={cradDetails}
            modulePreviewOpen={isPopupVisible}
            setModulePreviewOpen={closeCardDetailsModal}
          />
        )}


      </>
    );
  }

  return (
    <>
      {loading && (
        <CircularProgressBar isloading={loading} setIsloading={setLoading} />
      )}
      <div className="module-content-main">
        <div className="module-content-select-module">
          {closeTootltipTitle && <div className="d-flex module-content-tooltip">
                  <p>Associated module(s) from other topics have been added based on defined business rule(s)</p>
                  <img src={CrossIcon} alt="" width={18} onClick={closeTootltip} height={18} className="img-fluid"/>
                  <div className="tooltip-arrow"></div>
                </div>}
          <div className="d-flex align-items-center justify-content-between">
            {!modulePage && (
              <h2 className="module-content-select-module-text">
                {switchCustomJs &&
                  "View Business Rules associated with Modules"}
                {/* {switchCustomJs
                ? "View Business Rules associated with Modules"
                : `Select one or more Module (${moduleCardList.length})`} */}
              </h2>
            )}
            {switchCustomJs && <div className="module-content-toggle d-flex align-items-center ">
              <label className="toggle-label">Show All Selected</label>
              <label class="toggle-switch-btn">
                <input
                  type="checkbox"
                  checked={switchCustomJs}
                  name="switchToggle"
                  onClick={() =>
                    selectedModuleIds.length > 0 &&
                    setSwitchCustomJs(!switchCustomJs)
                  }
                />
                <span
                  class={`toggle-switch switch-round ${
                    selectedModuleIds.length > 0 ? "toggle-btn-on" : ""
                  }`}
                ></span>
              </label>
            </div>}
            
          </div>
        </div>
        {!switchCustomJs && (
          <div>
            <div className="d-flex align-items-center gap-3 module-content-text">
              {modulePage && <h2 className="module-content-select-text" style={{ fontWeight: 600, color: "1E1E1E" }}>
                Select one Template {`(${selectTemplateData.length})`}
              </h2>}
              {!modulePage && <h2
                className="module-content-select-text"
                style={{ fontWeight: 600, color: "1E1E1E" }}
              >
                Select one or more Module
              </h2>}
              <div className="vertical-line"></div>
              <div className="module-content-product-title d-flex gap-2">
                <div className="module-content-product-label">Product: </div>
                <div className="module-content-product-value">
                  {localdata?.brand?.name || "NA"}
                </div>
              </div>
              <div className="vertical-line"></div>
              <div className="module-content-country-title d-flex gap-2">
                <div className="module-content-country-label">Country: </div>
                <div className="module-content-country-value">
                  {localdata?.market?.name || "NA"}
                </div>
              </div>
            </div>
            <div className="module-content-dropdown">
              {/* <div className="module-content-dropdown-list">
                <TextFields
                  disabled={true}
                  width="160px"
                  height="42px"
                  id="filled-disabled"
                  label="Product"
                  // defaultValue="Biktarvy11"
                  defaultValue={localdata?.brand?.name}
                  key={localdata?.brand?.name}
                  variant="filled"
                  className="module-content-primary-product-field"
                />
              </div>
              <div className="module-content-dropdown-list">
                <TextFields
                  disabled={true}
                  id="filled-disabled"
                  label="Country"
                  defaultValue={localdata?.market?.name}
                  key={localdata?.market?.name}
                  variant="filled"
                  className="module-content-primary-product-field"
                />
              </div> */}
              {false && (
                <>
                  <div style={{ width: "200px" }}>
                    <SelectAutoComplete
                      options={[brands]}
                      disableValue={false}
                      value={""}
                      label="Topic"
                      required={true}
                      renderOption={templateListUI}
                      //onChange={handleFieldChanges}
                    />
                  </div>
                  <div style={{ width: "200px" }}>
                    <SelectAutoComplete
                      options={[]}
                      disableValue={true}
                      value={""}
                      label="Sub-Topic"
                      required={true}
                      renderOption={templateListUI}
                      //onChange={handleFieldChanges}
                    />
                  </div>
                  <div style={{ width: "200px" }}>
                    <SelectAutoComplete
                      options={[brands]}
                      disableValue={false}
                      value={""}
                      label="Segment"
                      required={true}
                      renderOption={templateListUI}
                      //onChange={handleFieldChanges}
                    />
                  </div>
                </>
              )}
              <div>
                <MultiSelectDropdownWithCount
                  options={indicationsList}
                  label="Indication"
                  value={indicationsList}
                  onChange={(val) => setSelectedIndications(val)}
                  placeholderText="Search & Select"
                  selected={selected}
                  setSelected={setSelected}
                  dropdownIcon={<img src={dropdownArrow} style={{marginRight: "3px", marginLeft: "3px"}} width={13} height={8} alt="" />}
                />
              </div>
              <div
                className="module-content-dropdown-list"
                style={{ display: "flex", flexGrow: "1" }}
              >
                {!modulePage && (
                  <SearchTextField
                    searchHandler={searchHandler}
                    handleEnterKeypress={handleEnterKeypress}
                    searchText={searchText}
                    cancelSearchField={cancelSearchField}
                    searchfieldsHandler={searchfieldsHandler}
                    placeholderName="Search by 'Module Name / ID'"
                  />
                )}
                {modulePage && (
                  <SearchTextFieldTemplate
                    onChangeText={searchTemplateHandler}
                    searchTextTemplate={searchTextTemplate}
                    removeText={clearField}
                    onSearch={getTemplate}
                    setSearchTextTemplate={setSearchTextTemplate}
                  />
                )}
              </div>
              <button
                className={`module-content-reset-button 
                        ${
                          enableResetBtn
                            ? "module-content-active-reset-button"
                            : "module-content-deactive-reset-button"
                        }`}
                disabled={enableResetBtn === true ? false : true}
                onClick={resetSelectedValue}
              >
                RESET FILTERS
              </button>
            </div>
            <div
              className="d-flex align-items-center justify-content-evenly"
              style={{ padding: "0 12px" }}
            >
              <h2 className="total-card">
                <span className="total-card-text">All</span>{" "}
                <span className="total-count">({modulePage ? selectTemplateData?.length : filteredData?.length})</span>
              </h2>
              <hr
                style={{ width: !modulePage ? "84%" : '96%', color: "#DDDFDD", opacity: "inherit" }}
              />
              {!modulePage && <div className="module-content-toggle d-flex align-items-center ">
                <label className="toggle-label">Show All Selected</label>
                <label class="toggle-switch-btn">
                  <input
                    type="checkbox"
                    checked={switchCustomJs}
                    name="switchToggle"
                    onClick={() =>
                      selectedModuleIds.length > 0 &&
                      setSwitchCustomJs(!switchCustomJs)
                    }
                  />
                  <span
                    class={`toggle-switch switch-round ${
                      selectedModuleIds.length > 0 ? "toggle-btn-on" : ""
                    }`}
                  ></span>
                </label>
              </div>}
            </div>
            {!modulePage && (
              <div
                className={`${filteredData?.length < 1 ? "noContent" : ""}`}
              >
                {moduleCardList?.length > 0 && filteredData?.length > 0 && (
                  <InfiniteScroll
                    dataLength={moduleCardList.length}
                    next={() => fetchMore(page + 1)}
                    hasMore={hasMore}
                    scrollableTarget="scrollableDivModule"
                    ref={infinteScrollRef}
                    // loader={<h4>Loading...</h4>}
                    scrollThreshold={0.9}
                  >
                    <div className="module-content-card-parent-div" id="scrollableDivModule">
                      <div className="module-content-card-child-div">
                        {filteredData &&
                          filteredData?.map((moduleList) => (
                            <ModuleListCard
                              disabledMustExistModules={disabledMustExistModules}
                              disabledModules={disabledModules}
                              getModuleStyle={getModuleStyle}
                              selectedModuleIds={selectedModuleIds}
                              selectedNextModuleList={selectedNextModuleList}
                              handleViewClick={handleViewClick}
                              handleCardClick={handleCardClick}
                              moduleList={moduleList}
                            />
                          ))}
                      </div>
                    </div>
                    {/* <div className='d-flex flex' style={{gap: "20px", flexWrap: "wrap", overflowX: "auto", maxHeight: "calc(100vh - 220px)", padding: "16px 42px 0px 42px"}}>
                            {moduleCardList && moduleCardList?.map(moduleList => <ModuleListCard disabledMustExistModules={disabledMustExistModules} disabledModules={disabledModules} getModuleStyle={getModuleStyle} selectedModuleIds={selectedModuleIds} selectedNextModuleList={selectedNextModuleList} handleViewClick={handleViewClick} handleCardClick={handleCardClick} moduleList={moduleList}/>)}
                        </div> */}
                  </InfiniteScroll>
                )}
                {/* && searchText.length > 0 */}
                {!loading && moduleCardList?.length > 0 && filteredData?.length === 0 && (
                  <div className="d-flex align-items-center justify-content-center">
                    <img src={NoImportResultFound} alt="No Modules Found" />
                  </div>
                )}
                {/* {(moduleCardList?.length === 0 && searchText.length > 0)&& (
                  <div className="d-flex align-items-center justify-content-center">
                    <img src={NoImportResultFound} />
                  </div>
                )}
                {(moduleCardList?.length === 0 && searchText.length === 0)&& (
                  <div className="d-flex align-items-center justify-content-center">
                    <img src={NoModuleImportFound} />
                  </div>
                )} */}
                {!loading && moduleCardList?.length === 0 && (
                  <div className="d-flex align-items-center justify-content-center">
                    {searchText?.length > 0 ? (
                      <img src={NoImportResultFound} alt="No search results" />
                    ) : (
                      <img src={NoModuleImportFound} alt="No modules found" />
                    )}
                  </div>
                )}
              </div>
            )}
            {modulePage && (
              <div
                className={`${
                  selectTemplateData?.length < 1 ? "noContent" : ""
                }`}
              >
                <InfiniteScroll
                  dataLength={selectTemplateData.length}
                  // dataLength={showFetchedResults.length}
                  next={() => fetchMoreTemplate("all", skipRange, true, false)}
                  hasMore={hasMoreTemplate}
                  scrollableTarget="scrollableDivTemplate"
                  ref={infinteScrollRef}
                  // loader={<h4>Loading...</h4>}
                  scrollThreshold={0.9}
                >
                  {selectTemplateData?.length > 0 && (
                    <div
                      className="module-content-card-parent-div"
                      id="scrollableDivTemplate"
                    >
                      <div className="module-content-card-child-div">
                        {selectTemplateData &&
                          selectTemplateData.map((cardData, index) => (
                            <SelectTemplateCard
                              cardData={cardData}
                              imageKey={index}
                              templateSelected={templateSelected}
                              setTemplatedSelected={setTemplatedSelected}
                              showFetchedResults={showFetchedResults}
                              setshowFetchedResults={setshowFetchedResults}
                              setPayloadData={setPayloadData}
                              payloadData={payloadData}
                              brandsList={brandsList}
                              countriesList={countriesList}
                            />
                          ))}
                      </div>
                    </div>
                  )}
                </InfiniteScroll>
                {/* {selectTemplateData?.length === 0 && (
                  <div className="d-flex align-items-center justify-content-center">
                    <img src={NoImportResultFound} />
                  </div>
                )} */}
                {!loading && selectTemplateData?.length === 0 && (
                  <div className="d-flex align-items-center justify-content-center">
                    {(searchTextTemplate?.length > 0 || selectedIndications.length > 0) ? (
                      <img src={NoImportResultFound} alt="No search results" />
                    ) : (
                      <img src={NoModuleImportFound} alt="No modules found" />
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {selectedModuleIds.length > 0 && switchCustomJs && (
          <div>
            <SelectedModuleModal
              selectedModuleIds={selectedModuleIds}
              moduleCardList={moduleCardList}
              localdata={localdata}
              moduleData={moduleData}
            />
          </div>
        )}
      </div>
      {/* {isPopupVisible && (
        <ModuleContentCardDetailsModal
          cradDetails={cradDetails}
          isPopupVisible={isPopupVisible}
          closeCardDetailsModal={closeCardDetailsModal}
        />
      )} */}
         {isPopupVisible && (
        <ModuleView
        modulePreviewData={cradDetails}
        modulePreviewOpen={isPopupVisible}
        setModulePreviewOpen={closeCardDetailsModal}
        />
      )}


    </>
  );
};

export default ModuleContent;
